/* Microdacyn redesign – product card → product page image morph.

   Horizon already ships the plumbing for cross-document view transitions
   (assets/view-transitions.js reads [data-view-transition-triggered], carries its type
   across the navigation in sessionStorage and re-applies it on pagereveal). What it does
   NOT cover here is either end: Horizon's own `transition_to_main_product` setting only
   decorates its <product-card> custom element, and this theme renders neither that card
   nor Horizon's product media gallery — the shop grid and the product page are both
   custom. Confirmed on the live preview: no element on the product page carried a
   view-transition name, and no stylesheet defined one.

   So the plumbing is reused and the two ends are wired here plus in mdc-view-transition.css.
   Only the clicked card is marked; the CSS names the product page's main image only in a
   document where no card was marked, which is what stops a product page that links to
   another product from putting the same name on two elements at once (a duplicate name
   makes the browser drop the transition entirely).

   The sessionStorage flag is read by the inline script in snippets/stylesheets.liquid,
   before first paint, to leave the scroll-reveal system off for the landing page. Without
   that, the browser snapshots the product page while its gallery is still at opacity 0
   waiting to reveal, and the morph appears to step through frames instead of gliding. */
(() => {
  const TYPE = 'mdc-product-image';

  const clear = () =>
    document.querySelectorAll('[data-view-transition-triggered]').forEach((el) => {
      el.removeAttribute('data-view-transition-triggered');
      el.removeAttribute('data-view-transition-type');
    });

  document.addEventListener(
    'click',
    (event) => {
      /* A modified click opens a new tab, so this page never swaps. Marking the card here
         would leave it armed and hand the morph to whatever navigation came next. */
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

      /* The card is a <div> now, with the link on its title stretched over the whole card
         by a pseudo-element - so the click still lands on an <a>, and the card is found
         from there. Matching the link rather than the card also means the add-to-cart
         button inside the card never arms a morph: it is a <button>, not a link. */
      const link = event.target instanceof Element ? event.target.closest('a') : null;
      if (!link || !(link.getAttribute('href') || '').includes('/products/')) return;

      const card = link.closest('.mdc-card');
      if (!card) return;

      const media = card.querySelector('.mdc-card__media');
      if (!media || !media.querySelector('img')) return;

      clear();
      media.setAttribute('data-view-transition-type', TYPE);
      media.setAttribute('data-view-transition-triggered', 'true');
      try {
        sessionStorage.setItem('mdc-morph', '1');
      } catch (e) {}

      /* If the navigation is prevented or simply never lands, disarm rather than leave a
         stale trigger behind. A slow server just loses the morph, which is the right way
         round to fail. */
      setTimeout(() => {
        clear();
        try {
          sessionStorage.removeItem('mdc-morph');
        } catch (e) {}
      }, 1500);
    },
    true
  );
})();
